module.exports = __webpack_public_path__ + "img/icon-video-chat.f2d6b95d.svg";